module.exports = __webpack_public_path__ + "img/1.ba6bd0e6.jpg";